enum NationalityEnum {
    CZ = "CZ",
    SK = "SK",
}

export default NationalityEnum;
